var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41058 4.41083C4.73602 4.08539 5.26366 4.08539 5.58909 4.41083L9.99984 8.82157L14.4106 4.41083C14.736 4.08539 15.2637 4.08539 15.5891 4.41083C15.9145 4.73626 15.9145 5.2639 15.5891 5.58934L11.1783 10.0001L15.5891 14.4108C15.9145 14.7363 15.9145 15.2639 15.5891 15.5893C15.2637 15.9148 14.736 15.9148 14.4106 15.5893L9.99984 11.1786L5.58909 15.5893C5.26366 15.9148 4.73602 15.9148 4.41058 15.5893C4.08514 15.2639 4.08514 14.7363 4.41058 14.4108L8.82133 10.0001L4.41058 5.58934C4.08514 5.2639 4.08514 4.73626 4.41058 4.41083Z",
    fill: "var(--grey-600)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.233cae0008a12612c710107990e09285.svg";
export { ForwardRef as ReactComponent };